import { HeaderActions } from './HeaderActions';
import { Logo } from './Logo';
import { Navigation } from './Navigation';

export function Header() {
  return (
    <header className="header fixed top-0 left-0 w-full max-w-[100vw] h-[70px] bg-md-background text-white flex items-center justify-center z-50">
      <div className="header_content w-full max-w-7xl lg:w-[75%] flex items-center justify-between lg:justify-start px-4 lg:px-0">
        <Logo />
        <Navigation />
        <HeaderActions />
      </div>
    </header>
  );
}
